import { SITE } from './actionTypes';

const actionType = SITE;

// ========================================
// TEMPLATE TIMELINE
// ========================================

export const toggleMenu = () => ({
  type: actionType.TOGGLE_MENU
});

export default toggleMenu;
